var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoices-history" },
    [
      _c("div", { staticClass: "is-flex space-between" }, [
        _c("h1", { staticClass: "title is-4 has-text-primary" }, [
          _vm._v("\n      Historial de Documentos\n    ")
        ]),
        _c("div", [
          _c("p", [
            _c(
              "a",
              {
                staticClass: "button is-primary",
                on: { click: _vm.downloadCfdis }
              },
              [
                _c("BIcon", { attrs: { icon: "cloud-download" } }),
                _c("span", [_vm._v(" Descarga Masiva")])
              ],
              1
            )
          ])
        ])
      ]),
      _c("AppPagination", {
        staticClass: "is-centered",
        attrs: {
          "current-page": _vm.currentPage,
          "buttons-max": _vm.buttonsMax,
          "pages-total": _vm.totalPages
        },
        on: { change: _vm.goToPage }
      }),
      _c(
        "div",
        { staticClass: "history-container" },
        [
          _c(
            "b-table",
            {
              attrs: {
                data: _vm.invoices,
                loading: _vm.isLoading,
                detailed: "",
                "has-detailed-visible": function(row) {
                  return row.operation.payments.length > 0
                },
                "row-class": function(row) {
                  return (
                    [201, 202].includes(row.operation.status) && "is-danger"
                  )
                },
                "mobile-cards": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(props) {
                    return [
                      _c(
                        "b-table-column",
                        {
                          attrs: {
                            field: "voucherSeries",
                            label: "Folio - Serie"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function(ref) {
                                  var column = ref.column
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "is-flex voucher-type-selector"
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(column.label) +
                                              "\n              "
                                          )
                                        ]),
                                        _c(
                                          "b-dropdown",
                                          {
                                            attrs: {
                                              hoverable: "",
                                              "aria-role": "list"
                                            },
                                            on: { change: _vm.onChangeType },
                                            model: {
                                              value: _vm.type,
                                              callback: function($$v) {
                                                _vm.type = $$v
                                              },
                                              expression: "type"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "filter",
                                                attrs: { slot: "trigger" },
                                                slot: "trigger"
                                              },
                                              [
                                                _c("b-icon", {
                                                  attrs: {
                                                    icon: "filter",
                                                    type: "is-info"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-dropdown-item",
                                              {
                                                attrs: {
                                                  focusable: false,
                                                  "aria-role": "menu-item",
                                                  custom: "",
                                                  paddingless: ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "form",
                                                  { attrs: { action: "" } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "modal-card",
                                                        staticStyle: {
                                                          width: "250px"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "modal-card-body"
                                                          },
                                                          [
                                                            _c(
                                                              "b-field",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "Buscar por Serie"
                                                                }
                                                              },
                                                              [
                                                                _c("b-input", {
                                                                  attrs: {
                                                                    name:
                                                                      "voucherSeries",
                                                                    value:
                                                                      _vm.$route
                                                                        .query
                                                                        .voucherSeries,
                                                                    placeholder:
                                                                      "A"
                                                                  },
                                                                  nativeOn: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onInputSearcherRouter(
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "b-field",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "Buscar por Folio"
                                                                }
                                                              },
                                                              [
                                                                _c("b-input", {
                                                                  attrs: {
                                                                    name:
                                                                      "voucherConsecutive",
                                                                    value:
                                                                      _vm.$route
                                                                        .query
                                                                        .voucherConsecutive,
                                                                    placeholder:
                                                                      "123"
                                                                  },
                                                                  nativeOn: {
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.onInputSearcherRouter(
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm.$route.query.voucherSeries ||
                                        _vm.$route.query.voucherConsecutive
                                          ? _c(
                                              "router-link",
                                              {
                                                staticStyle: {
                                                  cursor: "pointer"
                                                },
                                                attrs: {
                                                  to: {
                                                    query: Object.assign(
                                                      {},
                                                      _vm.$route.query,
                                                      {
                                                        voucherSeries: undefined,
                                                        voucherConsecutive: undefined
                                                      }
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("b-icon", {
                                                  attrs: {
                                                    icon: "close",
                                                    type: "is-danger"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _c("span", [_vm._v(_vm._s(props.row.voucherSeries))]),
                          _c("span", { staticStyle: { padding: "0 .5rem" } }, [
                            _vm._v("-")
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(props.row.voucherConsecutive))
                          ])
                        ]
                      ),
                      _c(
                        "b-table-column",
                        {
                          attrs: { field: "voucherDate", label: "Fecha y Hora" }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("toHumanDateTime")(props.row.voucherDate)
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      props.row.voucherType !== "P"
                        ? _c(
                            "b-table-column",
                            {
                              attrs: {
                                field: "voucherTotal",
                                label: "Total",
                                centered: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("toCurrency")(
                                      props.row.voucherTotal,
                                      props.row.voucherCurrency
                                    )
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                        : _c(
                            "b-table-column",
                            {
                              attrs: {
                                field: "voucherTotal",
                                label: "Total",
                                centered: ""
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("toCurrency")(
                                      props.row.complement.payments[0].amount,
                                      props.row.complement.payments[0].currency
                                    )
                                  ) +
                                  "\n        "
                              )
                            ]
                          ),
                      _c(
                        "b-table-column",
                        {
                          attrs: { field: "voucherType", label: "Tipo" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function(ref) {
                                  var column = ref.column
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "is-flex voucher-type-selector"
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(column.label) +
                                              "\n              "
                                          )
                                        ]),
                                        _c(
                                          "b-dropdown",
                                          {
                                            attrs: {
                                              hoverable: "",
                                              "aria-role": "list"
                                            },
                                            on: { change: _vm.onChangeType },
                                            model: {
                                              value: _vm.type,
                                              callback: function($$v) {
                                                _vm.type = $$v
                                              },
                                              expression: "type"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "filter",
                                                attrs: { slot: "trigger" },
                                                slot: "trigger"
                                              },
                                              [
                                                _c("b-icon", {
                                                  attrs: {
                                                    icon: "filter",
                                                    type: "is-info"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._l(_vm.types, function(t) {
                                              return _c(
                                                "b-dropdown-item",
                                                {
                                                  key: t.value,
                                                  attrs: {
                                                    value: t.value,
                                                    "aria-role": "listitem"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(t.label) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            })
                                          ],
                                          2
                                        ),
                                        _vm.type
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  cursor: "pointer"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.cleanTypeSelected(
                                                      $event
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("b-icon", {
                                                  attrs: {
                                                    icon: "close",
                                                    type: "is-danger"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.voucherTypeLabel(_vm.voucherType(props.row))
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      _c(
                        "b-table-column",
                        {
                          attrs: {
                            field: "voucherPaymentMethod",
                            label: "Método de pago"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function(ref) {
                                  var column = ref.column
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "is-flex voucher-type-selector"
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(column.label) +
                                              "\n              "
                                          )
                                        ]),
                                        _c(
                                          "b-dropdown",
                                          {
                                            attrs: {
                                              hoverable: "",
                                              "aria-role": "list",
                                              position: "is-bottom-left"
                                            },
                                            on: { change: _vm.onChangeType },
                                            model: {
                                              value: _vm.type,
                                              callback: function($$v) {
                                                _vm.type = $$v
                                              },
                                              expression: "type"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "filter",
                                                attrs: { slot: "trigger" },
                                                slot: "trigger"
                                              },
                                              [
                                                _c("b-icon", {
                                                  attrs: {
                                                    icon: "filter",
                                                    type: "is-info"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-dropdown-item",
                                              {
                                                attrs: {
                                                  focusable: false,
                                                  "aria-role": "menu-item",
                                                  custom: "",
                                                  paddingless: ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "form",
                                                  { attrs: { action: "" } },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "modal-card",
                                                        staticStyle: {
                                                          width: "200px"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "modal-card-body"
                                                          },
                                                          [
                                                            _c(
                                                              "b-field",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "Tipo de documento"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "is-flex"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "b-radio-button",
                                                                      {
                                                                        attrs: {
                                                                          "native-value":
                                                                            "PUE",
                                                                          expanded:
                                                                            "",
                                                                          type:
                                                                            "is-primary"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.voucherPaymentMethodRadioButton,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.voucherPaymentMethodRadioButton = $$v
                                                                          },
                                                                          expression:
                                                                            "voucherPaymentMethodRadioButton"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "PUE"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "b-radio-button",
                                                                      {
                                                                        attrs: {
                                                                          "native-value":
                                                                            "PPD",
                                                                          expanded:
                                                                            "",
                                                                          type:
                                                                            "is-primary"
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.voucherPaymentMethodRadioButton,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.voucherPaymentMethodRadioButton = $$v
                                                                          },
                                                                          expression:
                                                                            "voucherPaymentMethodRadioButton"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "PPD"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm.$route.query.voucherPaymentMethod
                                          ? _c(
                                              "a",
                                              {
                                                staticStyle: {
                                                  cursor: "pointer"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.voucherPaymentMethodRadioButton =
                                                      ""
                                                  }
                                                }
                                              },
                                              [
                                                _c("b-icon", {
                                                  attrs: {
                                                    icon: "close",
                                                    type: "is-danger"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm.isExpired(props.row)
                            ? _c(
                                "BTooltip",
                                {
                                  attrs: {
                                    type: "is-danger",
                                    label: "El tiempo de pago expiró"
                                  }
                                },
                                [
                                  _c("span", { staticClass: "tag is-danger" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(props.row.voucherPaymentMethod) +
                                        "\n            "
                                    )
                                  ])
                                ]
                              )
                            : _c("span", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(props.row.voucherPaymentMethod) +
                                    "\n          "
                                )
                              ])
                        ],
                        1
                      ),
                      _c(
                        "b-table-column",
                        {
                          attrs: {
                            field: "operation.cfdiStatus",
                            label: "Estado CFDI"
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.getCfdiStatus(props.row)) +
                              "\n        "
                          )
                        ]
                      ),
                      _c(
                        "b-table-column",
                        { attrs: { field: "id", label: "Acciones" } },
                        [
                          _vm.voucherType(props.row) === "invoice"
                            ? _c("invoice-actions", {
                                attrs: { id: props.row.id, invoice: props.row }
                              })
                            : _vm._e(),
                          _vm.voucherType(props.row) === "pre"
                            ? _c("pre-invoice-actions", {
                                attrs: {
                                  id: props.row.id,
                                  "voucher-type": props.row.voucherType,
                                  invoice: props.row
                                }
                              })
                            : _vm._e(),
                          _vm.voucherType(props.row) === "autoInvoice"
                            ? _c("auto-invoice-actions", {
                                attrs: { id: props.row.id, invoice: props.row }
                              })
                            : _vm._e(),
                          _vm.voucherType(props.row) === "creditNote"
                            ? _c("credit-note-actions", {
                                attrs: { id: props.row.id, invoice: props.row }
                              })
                            : _vm._e(),
                          _vm.voucherType(props.row) === "payroll"
                            ? _c("payroll-actions", {
                                attrs: { id: props.row.id, invoice: props.row }
                              })
                            : _vm._e(),
                          _vm.voucherType(props.row) === "rep"
                            ? _c("rep-actions", {
                                attrs: { id: props.row.id, invoice: props.row }
                              })
                            : _vm._e(),
                          _vm.voucherType(props.row) === "salaryReceipt"
                            ? _c("salary-receipt-actions", {
                                attrs: { id: props.row.id, invoice: props.row }
                              })
                            : _vm._e(),
                          _vm.voucherType(props.row) === "saleNote"
                            ? _c("sale-note-actions", {
                                attrs: { id: props.row.id, invoice: props.row }
                              })
                            : _vm._e(),
                          _vm.voucherType(props.row) === "tradeTransfer"
                            ? _c("trade-transfer-actions", {
                                attrs: { id: props.row.id, invoice: props.row }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c("template", { slot: "empty" }, [
                _c("section", { staticClass: "section" }, [
                  _c(
                    "div",
                    { staticClass: "content has-text-grey has-text-centered" },
                    [
                      _c(
                        "p",
                        [
                          _c("b-icon", {
                            attrs: { icon: "emoticon-sad", size: "is-large" }
                          })
                        ],
                        1
                      ),
                      _c("p", [_vm._v("No has generado ningún documento")])
                    ]
                  )
                ])
              ])
            ],
            2
          )
        ],
        1
      ),
      _c("AppPagination", {
        staticClass: "is-centered",
        attrs: {
          "current-page": _vm.currentPage,
          "buttons-max": _vm.buttonsMax,
          "pages-total": _vm.totalPages
        },
        on: { change: _vm.goToPage }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }